/* ChandlerRocks "Into the deep": marine snow + scroll reveal.
   Loaded deferred from theme.liquid. No dependencies. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var snow = document.getElementById('fo-snow');
  if (snow) {
    for (var i = 0; i < 40; i++) {
      var s = document.createElement('i');
      var size = (2 + Math.random() * 4).toFixed(1);
      s.style.left = (Math.random() * 100).toFixed(2) + '%';
      s.style.width = size + 'px';
      s.style.height = size + 'px';
      if (reduce) {
        // Respect reduced motion: scatter statically (no rise animation) but still visible.
        s.style.bottom = 'auto';
        s.style.top = (Math.random() * 100).toFixed(1) + '%';
        s.style.opacity = '0.55';
      } else {
        s.style.animationDuration = (9 + Math.random() * 15).toFixed(1) + 's';
        s.style.animationDelay = (-Math.random() * 20).toFixed(1) + 's';
      }
      snow.appendChild(s);
    }
  }

  /* Scroll parallax on the light pools.
     The atmosphere layer is position:fixed, so the pools sat dead still while the
     page moved under them, which read as a flat backdrop rather than water. Now
     they rise as you scroll, and because they drift up and away rather than
     wrapping, the page genuinely gets darker the deeper you go. That is the whole
     "into the deep" idea, and it costs one composited transform. */
  var atmos = document.querySelector('.fo-atmos');
  if (atmos && !reduce) {
    var RISE = 0.38;           // fraction of scroll distance the pools travel
    var ticking = false;
    var apply = function () {
      /* Clamped to the slack built into .fo-atmos (100vh below the fold). Past that
         the layer's bottom edge would lift into view and the pools would vanish for
         the rest of the page, which is worse than them sitting still. */
      var max = window.innerHeight;
      var y = Math.min(window.pageYOffset * RISE, max);
      atmos.style.transform = 'translate3d(0,' + (-y).toFixed(1) + 'px,0)';
      ticking = false;
    };
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(apply);
    }, { passive: true });
    apply();
  }

  var reveals = document.querySelectorAll('.fo-reveal');
  if (!('IntersectionObserver' in window) || reduce) {
    reveals.forEach(function (el) { el.classList.add('fo-in'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('fo-in'); io.unobserve(e.target); }
    });
  }, { threshold: 0.12 });
  reveals.forEach(function (el) { io.observe(el); });
})();
